module.exports = __webpack_public_path__ + "static/energy_23-2b5733782bf0a9002030da9cdeddd046.jpg";